// extracted by mini-css-extract-plugin
export default {"consents-item__required":"consents-item__required__2uYLm"};